"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.TransferAPI = {
    getTransfers: function (companyId, filters) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/transfers", {
            params: filters,
        }).then(function (response) {
            var transfers = response.data;
            return transfers;
        });
    },
    getTransferById: function (companyId, transferId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/transfers/" + transferId).then(function (response) {
            var transfer = response.data;
            return transfer;
        });
    },
    createTransfer: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/transfers", createObject).then(function (response) {
            var transfer = response.data;
            return transfer;
        });
    },
    updateTransfer: function (companyId, transferId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/transfers/" + transferId, updateObject).then(function (response) {
            var transfer = response.data;
            return transfer;
        });
    },
};
//# sourceMappingURL=TransferAPI.js.map